import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Layout from './components/Layout'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Gallery from './pages/Gallery'
import Blog from './pages/Blog'
import HelpCenter from './pages/HelpCenter'
import Contact from './pages/Contact'
import Book from './pages/Book'
import GiftCard from './pages/GiftCard'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import BalancePayment from './pages/BalancePayment'
import ManualBalancePayment from './pages/ManualBalancePayment'
import NotFound from './pages/NotFound'
import InstallAppPrompt from './components/InstallAppPrompt'

function App() {
  return (
    <>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/help-center" element={<HelpCenter />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/book" element={<Book />} />
          <Route path="/gift-card" element={<GiftCard />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/balance-payment" element={<BalancePayment />} />
          <Route path="/manual-balance-payment" element={<ManualBalancePayment />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      <InstallAppPrompt />
      <Toaster 
        position="top-center"
        containerStyle={{ zIndex: 100002 }}
        toastOptions={{
          duration: 4000,
          style: {
            background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
            color: '#166534',
            border: '1px solid #bbf7d0',
          },
        }}
      />
    </>
  )
}

export default App
